<template>
  <div class="panel-group">
    <AdaptedGoalView
      v-for="(adaptedGoal, index) in adaptedGoals"
      :key="index"
      :position="index"
      :level="adaptedGoal.level"
      :level-label-mapping="levelLabelMapping"
      :expanded="activePanels[index] || false"
      :edited="hasBeenEdited(adaptedGoal)"
      :footer="adaptedGoal.example_text && adaptedGoal.example_text.length > 0 ? true : false"
      @toggle="togglePanel">
      <CopyTrackWrapper
        slot="body"
        type="goal"
        :title="goalTitle"
        :uuid="goalUuid"
        :level="adaptedGoal.level"
        :demo="accessInfo.demo"
      >
        <EditableWikiTextArea
          v-if="!accessInfo.blur && !readOnly"
          v-model="adaptedGoal.text"
          :strategies="strategies"
          @textEdited="notifyAdaptedGoalEdited(adaptedGoal)"
          @textReset="notifyAdaptedGoalReset(adaptedGoal)"
        />
        <WikiText
          v-if="accessInfo.blur || readOnly"
          :text="adaptedGoal.text"
          :strategies="strategies"
          :locked="accessInfo.blur"
          lock-mode="always_snippet_first_block"
          :plaintext="accessInfo.blur"
        />
      </CopyTrackWrapper>
      <CopyTrackWrapper
        slot="footer"
        type="goal-example"
        :title="goalTitle"
        :uuid="goalUuid"
        :demo="accessInfo.demo">
        <WikiText :text="adaptedGoal.example_text" :locked="accessInfo.blur" />
      </CopyTrackWrapper>
    </AdaptedGoalView>
  </div>
</template>

<script>
import { adaptedGoalOrObjectiveLevelLabelMapping } from '@/util/goals'
import AdaptedGoalView from '@/components/goals/AdaptedGoalView'
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import WikiText from '@/components/WikiText'
import EditableWikiTextArea from '@/components/EditableWikiTextArea'

export default {
  name: 'AdaptedGoalsAccordion',
  components: {
    AdaptedGoalView,
    CopyTrackWrapper,
    WikiText,
    EditableWikiTextArea
  },
  props: {
    adaptedGoals: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(adaptedGoal => adaptedGoal.level && adaptedGoal.text)
      }
    },
    initialExpandedLevel: {
      type: String,
      default: ''
    },
    strategies: {
      type: Object,
      default() {
        return {}
      }
    },
    originalGoals: {
      type: Array,
      default() {
        return []
      }
    },
    accessInfo: {
      type: Object,
      required: true
    },
    subject: {
      type: String,
      required: true
    },
    goalUuid: {
      type: String,
      required: true
    },
    goalTitle: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activePanels: {}
    }
  },
  computed: {
    levelLabelMapping() {
      return adaptedGoalOrObjectiveLevelLabelMapping(this.subject)
    }
  },
  methods: {
    togglePanel(index) {
      let collapsed = ''
      if (this.activePanels[index]) {
        collapsed = 'hide'
      } else {
        collapsed = 'show'
      }

      this.$set(this.activePanels, index, !this.activePanels[index])
      Object.keys(this.activePanels).forEach(i => {
        if (parseInt(i) !== index) {
          this.activePanels[i] = false
        }
      })
      this.$emit('adaptedGoal:paneltoggle', {
        level: this.adaptedGoals[index].level,
        collapsed
      })
    },
    notifyAdaptedGoalReset(adaptedGoal) {
      this.$emit('adaptedGoal:reset', { level: adaptedGoal.level, text: adaptedGoal.text })
    },
    notifyAdaptedGoalEdited(adaptedGoal) {
      this.$emit('adaptedGoal:edited', { level: adaptedGoal.level, text: adaptedGoal.text })
    },
    hasBeenEdited(adaptedGoal) {
      var original = this.originalGoals.filter(goal => {
        return goal.level === adaptedGoal.level
      })
      if (this.originalGoals.length === 0 || original.length === 0) {
        return false
      }
      return original[0].text !== adaptedGoal.text
    }
  },
  created() {
    if (this.adaptedGoals && this.adaptedGoals.length > 0 && this.initialExpandedLevel) {
      const i = this.adaptedGoals.findIndex(g => g.level === this.initialExpandedLevel)
      this.$set(this.activePanels, i, true)
    }
  }
}
</script>
